import React from 'react';
import {
  VictoryAxis,
  VictoryBar,
  VictoryChart,
  VictoryLabel,
  VictoryTheme,
} from 'victory';

const Chart = ({ xLabel, yLabel, xAxisColor, yAxisColor, myData }) => {
  return (
    <div style={{ width: '70%', height: '70%', background: 'pink' }}>
      <VictoryChart theme={VictoryTheme.material} domainPadding={{ x: 40 }}>
        {/* x-axis component */}
        <VictoryAxis
          label={xLabel}
          style={{
            axis: { stroke: xAxisColor },
            axisLabel: { fontSize: 10, padding: 30 },
            tickLabels: {
              fontWeight: 400,
              stroke: '#61dafb ',
              fontSize: 7,
              marginBlock: '20px',
            },
            grid: { stroke: 'lightgrey', opacity: '0.8' },
          }}
          tickLabelComponent={<VictoryLabel data={myData} />}
        />

        {/* y-axis component */}
        <VictoryAxis
          dependentAxis
          label={yLabel}
          style={{
            axis: { stroke: yAxisColor },
            axisLabel: { fontSize: 10, padding: 30 },
            tickLabels: {
              fontWeight: 400,
              stroke: '#61dafb ',
              fontSize: 7,
              marginBlock: '50px',
            },
            grid: { stroke: 'lightgrey', opacity: '0.6' },
          }}
          tickLabelComponent={<VictoryLabel data={myData} />}
        />
        <VictoryBar
          barRatio={0.8}
          style={{
            data: { fill: 'none' },
          }}
          data={myData}
        />
      </VictoryChart>
    </div>
  );
};

export default Chart;
